import Vue from 'vue';
import Router from 'vue-router';

import Main from '@/pages/main';
import TimeMain from '@/pages/time/index';
import TimeNumber from '@/pages/time/number/index';
import TimeNumberStart from '@/pages/time/number/start';
import TimeCard from '@/pages/time/card/index';
import TimeCardStart from '@/pages/time/card/start';
import TrainingMain from '@/pages/training/index';
import TrainingNumber from '@/pages/training/number/index';
import TrainingNumberStart from '@/pages/training/number/start';
import TrainingNumberRecall from '@/pages/training/number/recall';
import TrainingNumberResult from '@/pages/training/number/result';
import TrainingCard from '@/pages/training/card/index';
import TrainingCardStart from '@/pages/training/card/start';
import TrainingCardRecall from '@/pages/training/card/recall';
import TrainingCardResult from '@/pages/training/card/result';
import TrainingImage from '@/pages/training/image/index';
import TrainingImageStart from '@/pages/training/image/start';
import TrainingImageRecall from '@/pages/training/image/recall';
import TrainingImageResult from '@/pages/training/image/result';
import Auth from '@/pages/auth';

import Result from '@/pages/result';

Vue.use(Router);

export default function () {
  const config = {
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
      { path: '/', name: 'Main', component: Main },
      { path: '/time', name: 'Time', component: TimeMain },
      { path: '/time/number', name: 'TimeNumber', component: TimeNumber },
      { path: '/time/number/start', name: 'TimeNumberStart', component: TimeNumberStart },
      { path: '/time/card', name: 'TimeCard', component: TimeCard },
      { path: '/time/card/start', name: 'TimeCardStart', component: TimeCardStart },

      { path: '/training', name: 'Training', component: TrainingMain },
      { path: '/training/number', name: 'TrainingNumber', component: TrainingNumber },
      { path: '/training/number/start', name: 'TrainingNumberStart', component: TrainingNumberStart },
      { path: '/training/number/recall', name: 'TrainingNumberRecall', component: TrainingNumberRecall },
      { path: '/training/number/result', name: 'TrainingNumberResult', component: TrainingNumberResult },

      { path: '/training/card', name: 'TrainingCard', component: TrainingCard },
      { path: '/training/card/start', name: 'TrainingCardStart', component: TrainingCardStart },
      { path: '/training/card/recall', name: 'TrainingCardRecall', component: TrainingCardRecall },
      { path: '/training/card/result', name: 'TrainingCardResult', component: TrainingCardResult },

      { path: '/training/image', name: 'TrainingImage', component: TrainingImage },
      { path: '/training/image/start', name: 'TrainingImageStart', component: TrainingImageStart },
      { path: '/training/image/recall', name: 'TrainingImageRecall', component: TrainingImageRecall },
      { path: '/training/image/result', name: 'TrainingImageResult', component: TrainingImageResult },

      { path: '/result', name: 'Result', component: Result },
      { path: '/auth', name: 'Auth', component: Auth },
    ],
  };

  const router = new Router(config);
  // router.beforeEach((to, from, next) => {
  //   const auth = store.state.app.auth;
  //   if (to.path === '/auth') {
  //     return next();
  //   }
  //   if (!auth) {
  //     return next({ path: '/auth', replace: true });
  //   }
  //   return next();
  // });

  return router;
}



// WEBPACK FOOTER //
// ./src/router/index.js